import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WebSiteUsersService } from '../../../services/webSiteUsers/webSiteUsers.service';

@Component({
    selector: 'forgetpassword',
    templateUrl: 'forgetpassword.component.html',
    styleUrls: ['forgetpassword.component.scss']
})
export class ForgetpasswordComponent {
    email = "";
    loader: boolean = false;
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private router: Router
    ) {
    }
    send() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            this.loader = false;
        } else {
            this.loader = true;
            this.webSiteUsersService.forgetPassword(this.email).subscribe(
                (data: any) => {
                    this.loader = false;
                    if (data.success) {
                        this.toastr.success('Merci de consulter votre boite e-mail pour obtenir votre mot de passe');
                        this.router.navigate(['/compte/connexion']);
                    } else {
                        this.toastr.error('Aucun compte trouvé');
                    }
                },
                (err) => {
                    this.loader = false;
                }
            )
        }
    }
}
